/** @format */

import { Injectable, inject } from '@angular/core';
import { FeatureConfigurationService } from '@shared/data-access/services';
import { PersonalizationDataKeys } from '@shared/data-access/enums';
import { PersonalizedInfoCalloutContent } from '../interfaces/personalized-info-callout.interface';

/** @description Loads the PDP info callout content from the personalization service. */
@Injectable({
  providedIn: 'root',
})
export class PersonalizedInfoCalloutService {
  private readonly featureConfigurationService = inject(FeatureConfigurationService);
  // Additive content with nothing to fall back to, so a timer would only discard it (Infinity = no timeout in pz).
  private readonly PERSONALIZATION_TIMEOUT_MS = Infinity;

  getContent(): Promise<PersonalizedInfoCalloutContent | null> {
    return this.loadContent();
  }

  private loadContent(): Promise<PersonalizedInfoCalloutContent | null> {
    return this.featureConfigurationService.getPersonalization<PersonalizedInfoCalloutContent | null>(
      PersonalizationDataKeys.MODIFY_PDP_INFO_CALLOUT,
      null,
      { timeout: this.PERSONALIZATION_TIMEOUT_MS },
    );
  }
}
